var map = {
	"./A1.jpeg": 9195,
	"./A2.jpg": 121,
	"./A3.jpg": 5772,
	"./B1.jpeg": 7132,
	"./B2.jpg": 5332,
	"./B3.jpg": 3857,
	"./admin1.jpg": 4470,
	"./admin2.png": 8633,
	"./admin3.jpg": 6772,
	"./admin4.jpg": 1711,
	"./admin5.jpg": 9330,
	"./admin6.jpg": 9229,
	"./admin7.jpeg": 6361,
	"./creditos1.png": 832,
	"./creditos2.png": 8475,
	"./glosario13_1.jpg": 4386,
	"./glosario13_2.jpg": 3613,
	"./glosario13_3.jpg": 8720,
	"./glosario13_4.jpg": 7523,
	"./glosario14.jpg": 4301,
	"./glosario16_1.jpg": 2331,
	"./glosario16_2.jpg": 3996,
	"./glosario16_3.jpg": 5049,
	"./glosario16_4.jpg": 4154,
	"./glosario16_5.jpg": 6343,
	"./glosario16_6.jpg": 2536,
	"./glosario16_7.jpg": 405,
	"./glosario16_8.jpg": 7510,
	"./glosario17_1.jpg": 9398,
	"./glosario17_2.jpg": 7169,
	"./glosario18.jpg": 3113,
	"./glosario19.jpg": 5068,
	"./glosario21.jpg": 2189,
	"./glosario2_2_5.jpg": 685,
	"./glosario2_4.jpg": 7087,
	"./glosario7.png": 4971,
	"./glosario7_1.jpg": 3639,
	"./home1.png": 2280,
	"./home2.png": 7891,
	"./home3.png": 5978,
	"./home4.png": 6405,
	"./home5.png": 492,
	"./home6.png": 8071,
	"./home7.png": 4926,
	"./logo.png": 3153,
	"./logo.svg": 3935,
	"./logo2.png": 4343,
	"./logo2o.png": 5168,
	"./logo3.png": 8558,
	"./logo4.png": 3121,
	"./logo4_1.png": 657,
	"./recurso1.png": 4786,
	"./recurso2.png": 2969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;